'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
  .controller('MainCtrl', ['$scope',function ($scope) {

      $scope.carouselInterval = false; //milliseconds


  }]);
